module.exports = __webpack_public_path__ + "img/Kyrgyz Republic.a07e9b64.svg";